import React, { useState } from 'react';
import './BrandFooter.css';

// Full "MUSEUM X" lockup as a single image asset, pinned to the bottom of
// every screen.
//   Asset: museumx/frontend/public/assets/museum_x_text.png
const LOCKUP_SRC = `${process.env.PUBLIC_URL}/assets/museum_x_text.png`;

export default function BrandFooter() {
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <div className="brand-footer" aria-label="MUSEUM X">
      {imgFailed ? (
        <span className="brand-fallback">
          MUSEUM <span className="brand-fallback-x">×</span>
        </span>
      ) : (
        <img
          src={LOCKUP_SRC}
          alt="MUSEUM X"
          className="brand-lockup-img"
          onError={() => setImgFailed(true)}
          draggable={false}
        />
      )}
    </div>
  );
}
